import React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

// Inline expansion under a per-location package variant: the buyer picks which
// location the sessions will be redeemable at before confirming.
function LocationPicker({ locations, onClose, onPick }) {
  return (
    <Box sx={{ p: 2.5, borderRadius: 2.5, border: "1.5px solid", borderColor: "primary.main", bgcolor: (t) => alpha(t.palette.primary.main, 0.04) }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
        <Typography sx={{ fontSize: "0.95rem", fontWeight: 700 }}>Choose a location</Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
        Your sessions will be redeemable at the location you pick.
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
          gap: 1.25
        }}
      >
        {locations.map((loc) => (
          <ButtonBase
            key={loc._id}
            onClick={() => onPick(loc._id)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              py: 1.5,
              px: 1.75,
              borderRadius: 2,
              border: "1.5px solid",
              borderColor: "divider",
              bgcolor: "#fff",
              transition: "all 0.15s ease",
              "&:hover": { borderColor: "primary.main", boxShadow: "0 4px 12px rgba(26,26,26,0.08)" }
            }}
          >
            <PlaceOutlinedIcon sx={{ fontSize: "1.125rem", color: "primary.main", flexShrink: 0 }} />
            <Typography sx={{ flex: 1, fontSize: "0.85rem", fontWeight: 600, textAlign: "left" }}>{loc.name}</Typography>
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
}

export default LocationPicker;
